import type { AssetOperation } from '../../types'

import type { Action } from 'fc-flow-types/redux'

import { put, call } from 'redux-saga/effects'

// Operator
import operator from 'fc-operator-asset/src/operator'

import { validateModel } from 'fc-model-assets'

export default function *validateOperationSaga (operation: AssetOperation): Generator<*, *, *> {
  const errors = yield call(validateModel, operation.model)

  const nextOperation = {
    ...operation,
    submitting: false,
    errors,
  }

  const action: Action<Object> = yield operator.actionCreators.updateOperation(nextOperation)

  yield put(action)

  return nextOperation
}
